import packageJson from 'package.json';

export const environment = {
  version: packageJson.version,
  API_ENDPOINT: 'https://loadtest-api.q9elements.com/api/v1',
  API_STATIC_FILE_UPLOAD: 'https://loadtest-upload.q9elements.com:1443/api',
  MAIN_APP_URL: 'https://loadtest-app.q9elements.com',
  NO_IMAGE_URL: '../../assets/images/no_image.png',
  ENTERPRISE_URL: 'https://loadtest-corp.q9elements.com',
  PARTNER_APP: 'https://loadtest-partnermgt.q9elements.com',
  PREVIEW_HOLDER: '/assets/images/map_placeholder.png',
  production: true,
  SENTRY_AUTH_TOKEN: '',
  SENTRY_DSN: '',
  SENTRY_ORG: '',
  SENTRY_PROJECT: 'sysadmin-app',
  RELEASE_URL: 'https://loadtest-releasemgt.q9elements.com',
  DATA_STRUCTURE_URL: 'https://loadtest-datatable.q9elements.com',
  TEAM_APP: 'https://loadtest-spacemgt.q9elements.com',
  REF_MODEL_APP: 'https://loadtest-refmodel.q9elements.com',
  REPORTS_API_ENDPOINT: 'https://loadtest-gateway.q9elements.com/report/api/v1',
  REPORTS_APP: 'https://loadtest-report.q9elements.com',
  TOASTR_TIMEOUT: 3000,
  INTERCOM_APP_ID: 'sfi4u1en',
  REMOTE_UNLOCK_TTL: 3600000,
  UNLOCK_TTL: 180000,
  SALESFORCE_URL: 'https://login.salesforce.com/services/oauth2/authorize',
  SALESFORCE_URL_TEST: 'https://test.salesforce.com/services/oauth2/authorize',
  SALESFORCE_REDIRECT_URL: 'https://loadtest-app.q9elements.com/auth/callback',
  SALESFORCE_CLIENT_ID: '3MVG9Rd3qC6oMalVszZtK2Usdv9bqy4_doe6P1BuqzckkUu1t0JC1aW.e13T.i_8rQ3P8A9goskWvf4iLeabN',
  SECURE_COOKIES: true,
  SYS_ADMIN_APP: 'https://loadtest-sysadmin.q9elements.com',
  STATIC_FILES_URL: 'https://static.elements.cloud',
  JAM_TEAM_ID: '',
  MCP_OAUTH_URL: 'https://loadtest-api.q9elements.com/api/v1/oauth',
  fbConfig: {
      apiKey:'AIzaSyC1scjCnEIl0p3hNSXPd7xv0gZInlcwr6M',
      authDomain:'elements-loadtest.firebaseapp.com',
      databaseURL: 'https://elements-loadtest-default-rtdb.firebaseio.com/',
      projectId: 'elements-loadtest',
      appId: '1:201990050997:web:3b9c59c614dcc81aea1afc'
  }
};
